import { useEffect, useState } from 'react';
import { TUIStore, StoreName, TUIConversationService } from '@tencentcloud/chat-uikit-engine';
import {
  Chat,
  ChatHeader,
  MessageList,
  MessageInput,
  Profile,
  ConversationList,
  ChatSetting,
} from '@tencentcloud/chat-uikit-react';
import { UIKitProvider } from '@tencentcloud/uikit-base-component-react';
import { useOutlet } from '@/context/OutletContext';
import Mobile from '@/layout/Mobile';

import './InboxMobile.scss';

function InboxMobile() {
  const { theme, language, chat } = useOutlet();
  const [currentConversationID, setCurrentConversationID] = useState<string>('');

  useEffect(() => {
    TUIStore.watch(StoreName.CONV, {
      currentConversationID: onCurrentConversationIDUpdated,
    });
    // ensure that the current conversation ID is empty when switching to Mobile mode
    TUIConversationService.switchConversation('');

    return () => {
      TUIStore.unwatch(StoreName.CONV, {
        currentConversationID: onCurrentConversationIDUpdated,
      });
    };
  }, []);

  function onCurrentConversationIDUpdated(conversationID: string) {
    setCurrentConversationID(conversationID);
  }

  return (
    <Mobile>
      <UIKitProvider chat={chat} language={language} theme={theme}>
        {!currentConversationID && (
          <>
            <Profile />
            <ConversationList />
          </>
        )}
        {currentConversationID && (
          <>
            <Chat>
              <ChatHeader />
              <MessageList />
              <MessageInput />
            </Chat>
            <ChatSetting />
          </>
        )}
      </UIKitProvider>
    </Mobile>
  );
}

export default InboxMobile;
